import React, { useState } from "react";
import useSize from "../../../Utils/useSize/useSize.js";
import Header from "./Header/Header";

import Create from "./Create/Create";
import Summary from "./Summary/Summary";

import SuperList from "./SuperList/SuperList";

export default function Master() {
  const windowSize = useSize();

  const [type, setType] = useState(2);

  return (
    <div
      style={{
        height: windowSize[1] - 100,
      }}
    >
      <Header type={type} updateType={(a) => setType(a)} />

      {type === 0 ? <Create updateType={(a) => setType(a)} /> : null}
      {type === 1 ? <Summary /> : null}
      {type === 2 ? <SuperList /> : null}
    </div>
  );
}
